module.exports = __webpack_public_path__ + "static/media/utsa_logo.e90045d9.svg";